import isExternalSrcImageUtil from 'components/Image/utils/is-external-src'
import sanitizeSrcImageUtil from 'components/Image/utils/sanitize-src'
import isFromTrainingCdnSrcImageUtil from 'components/Image/utils/is-from-training-cdn-src'

export default function getUrlImageUtil (src, hasWebpSupport) {
  if (!src) {
    return ''
  }
  if (isExternalSrcImageUtil(src)) {
    return src
  }

  src = sanitizeSrcImageUtil(src)
  if (hasWebpSupport) {
    src = src.replace(/\.(jpg|png)/, '.webp')
  }

  if (isFromTrainingCdnSrcImageUtil(src)) {
    return src
  }

  return `${AWS_CLOUD_FRONT_URL}${src}`
}
